import { Button, type ButtonProps } from 'antd';
import { getGeneralButtonStyle } from '@/components/buttons/utils/getGeneralButtonStyle';
import type { VFC } from 'react';
import styled from 'styled-components';
import { getButtonStyleByType } from '../../utils/getButtonStyleByType';

export const StyledButton: typeof Button = styled(Button)<VFC<ButtonProps>>`
  &.ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;

    // STYLES FOR ALL BUTTONS
    ${getGeneralButtonStyle}

    // STYLES FOR BUTTONS WITH DIFFERENT TYPES
    ${({ type }) => getButtonStyleByType(type)}
  }
`;
